export function isValidEmail(
  text: string | null | undefined
): boolean {
  if (text === undefined || text === null) {
    return false
  } else {
    return /\S+@\S+\.\S+/.test(text ?? "")
  }
}